<template>
  <RevLink
    class="flex h-full flex-nowrap items-center gap-12"
    :style="{ color }"
    :to="url"
    :underlined="false"
    @click="toggle"
  >
    <component
      :is="icons[icon]"
      v-if="icon"
      :data-test="`icon-${icon.toLowerCase()}`"
    />
    <span>{{ title }}</span>
  </RevLink>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { RevLink } from '@ds/components/Link'
import { IconGift } from '@ds/icons/IconGift'
import { IconSparkles } from '@ds/icons/IconSparkles'
import { IconSwap } from '@ds/icons/IconSwap'

import { useNavigation } from '../../composables/useNavigation'

defineProps<{
  title: string
  color?: string
  icon?: string
  url: string
}>()
const { toggle } = useNavigation()

const icons: { [key: string]: Component } = {
  Sparkles: IconSparkles,
  Swap: IconSwap,
  IconGift,
}
</script>
